<template>
  <div class="home">
    <div class="container">
      <ais-instant-search
        index-name="id"
        :searchClient="searchClient"
        indexName="subids"
      >
        <div class="section">
          <h2>search</h2>
          <ais-search-box placeholder="Search for products..." />
        </div>
        <div class="section">
          <ais-hits>
            <table
              class="table is-striped"
              id="data-table"
              slot-scope="{ items }"
            >
              <thead>
                <tr>
                  <th>ECP ID</th>
                  <th>Cake ID</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in items" :key="item.objectID">
                  <th><ais-highlight :hit="item" attribute="id" /></th>
                  <td>
                    <ais-highlight :hit="item" attribute="plain" />
                  </td>
                </tr>
              </tbody>
            </table>
          </ais-hits>
        </div>
      </ais-instant-search>
      <button class="button" id="sign-out-btn" @click="signOut">
        sign out
      </button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import algoliasearch from "algoliasearch/lite";

export default {
  name: "Dashboard",
  data() {
    return {
      subids: [],
      subidFilter: null,
      idFilter: null,
      searchClient: algoliasearch(
        "Y6MEMZF8R8",
        "f5b75337f39199d3ddf0ca8369af4654"
      )
    };
  },
  components: {},
  methods: {
    signOut() {
      firebase.auth().signOut();
      window.location = "/login";
    }
  }
};
</script>

<style lang="scss" scoped>
#data-table {
  margin: 0 auto;
}
#sign-out-btn {
  position: absolute;
  right: 25px;
  top: 25px;
}
</style>
